export default __webpack_public_path__ + "static/media/background.683f0bea.webp";